import { render, staticRenderFns } from "./map_schema.vue?vue&type=template&id=5965a6b2"
import script from "./map_schema.vue?vue&type=script&lang=js"
export * from "./map_schema.vue?vue&type=script&lang=js"
import style0 from "./map_schema.vue?vue&type=style&index=0&id=5965a6b2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports